"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureValueFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var MeasureValueFilterDropdown_1 = require("./MeasureValueFilterDropdown");
var MeasureValueFilterButton_1 = tslib_1.__importDefault(require("./MeasureValueFilterButton"));
/**
 * @beta
 */
var MeasureValueFilter = /** @class */ (function (_super) {
    tslib_1.__extends(MeasureValueFilter, _super);
    function MeasureValueFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            displayDropdown: false,
        };
        _this.buttonRef = react_1.default.createRef();
        _this.onApply = function (filter) {
            _this.closeDropdown();
            _this.props.onApply(filter);
        };
        _this.onCancel = function () {
            _this.closeDropdown();
            _this.props.onCancel();
        };
        _this.closeDropdown = function () {
            _this.setState({ displayDropdown: false });
        };
        _this.toggleDropdown = function () {
            _this.setState(function (state) { return (tslib_1.__assign(tslib_1.__assign({}, state), { displayDropdown: !state.displayDropdown })); });
        };
        return _this;
    }
    MeasureValueFilter.prototype.render = function () {
        var displayDropdown = this.state.displayDropdown;
        var _a = this.props, filter = _a.filter, measureIdentifier = _a.measureIdentifier, buttonTitle = _a.buttonTitle, usePercentage = _a.usePercentage, warningMessage = _a.warningMessage, locale = _a.locale, separators = _a.separators, displayTreatNullAsZeroOption = _a.displayTreatNullAsZeroOption, treatNullAsZeroDefaultValue = _a.treatNullAsZeroDefaultValue, enableOperatorSelection = _a.enableOperatorSelection;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { ref: this.buttonRef },
                react_1.default.createElement(MeasureValueFilterButton_1.default, { onClick: this.toggleDropdown, isActive: displayDropdown, buttonTitle: buttonTitle })),
            displayDropdown ? (react_1.default.createElement(MeasureValueFilterDropdown_1.MeasureValueFilterDropdown, { onApply: this.onApply, onCancel: this.onCancel, filter: filter, measureIdentifier: measureIdentifier, usePercentage: usePercentage, warningMessage: warningMessage, locale: locale, separators: separators, displayTreatNullAsZeroOption: displayTreatNullAsZeroOption, treatNullAsZeroDefaultValue: treatNullAsZeroDefaultValue, enableOperatorSelection: enableOperatorSelection, anchorEl: this.buttonRef.current })) : null));
    };
    MeasureValueFilter.defaultProps = {
        onCancel: noop_1.default,
    };
    return MeasureValueFilter;
}(react_1.default.PureComponent));
exports.MeasureValueFilter = MeasureValueFilter;
//# sourceMappingURL=MeasureValueFilter.js.map